import { render, staticRenderFns } from "./Vendor.vue?vue&type=template&id=b18d6070&"
import script from "./Vendor.vue?vue&type=script&lang=js&"
export * from "./Vendor.vue?vue&type=script&lang=js&"
import style0 from "./Vendor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports